import RoomListPagingResultModelBase from '../_generated/modelBases/room-list-paging-result-model-base';

export default class RoomListPagingResultModel extends RoomListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
